import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterprisePinMaps } from 'src/app/models/enterprise/enterprisePinMaps';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { ZoneService } from 'src/app/services/zone/zone.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { environment } from 'src/environments/environment';
import { ModalCameraCounterComponent } from './modal-camera-counter/modal-camera-counter.component';
import { CameraService } from 'src/app/services/camera/camera.service';

@Component({
  selector: 'app-modal-list-camera-counter',
  templateUrl: './modal-list-camera-counter.component.html',
  styleUrls: ['./modal-list-camera-counter.component.css'],
})
export class ModalListCameraCounterComponent implements OnInit {
  pinMapfiles: File[] = [];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['name', 'action'];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  listPinMaps = [];

  constructor(
    public dialogRef: MatDialogRef<ModalListCameraCounterComponent>,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private cameraService: CameraService,
    private alertService: AlertService,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.getList();
  }

  closeModal() {
    this.dialogRef.close();
  }

  getList() {
    this.spinner.show();
    this.cameraService.getListRegionsCameraCounter(this.data.obj.id).subscribe(
      (response) => {
        this.listPinMaps = response.data;
        this.dataSource.data = this.listPinMaps;
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  deletePinMap(obj) {
    this.spinner.show();
    this.cameraService.deleteRegionCameraCounter(obj.id).subscribe(
      (response) => {
        this.alertService.showMessage(
          AppConstants.TitleModal.DELETE_REGION_CAMERA_COUNTER,
          AppConstants.MessageModal.DELETE,
          MessageSeverity.success
        );
        this.getList();
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(
          AppConstants.TitleModal.DELETE_REGION_CAMERA_COUNTER,
          error.error.messages,
          MessageSeverity.error
        );
        this.spinner.hide();
      }
    );
  }

  addModalPin() {
    let dialogRef = this.dialog.open(ModalCameraCounterComponent, {
      data: {
        action: AppConstants.OperationType.ADD,
        title: AppConstants.TitleModal.CREATE_REGION_CAMERA_COUNTER,
        idCamera: this.data.obj.id,
        idEnterprise: this.data.idEnterprise,
        idHeadquarter: this.data.idHeadquarter,
        headquarters: this.data.headquarters,
      },
      width: '500px',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((_) => {
      if (_.result) {
        this.getList();
      }
    });
  }

  editPinMap(obj) {
    let dialogRef = this.dialog.open(ModalCameraCounterComponent, {
      data: {
        action: AppConstants.OperationType.UPDATE,
        title: AppConstants.TitleModal.EDIT_REGION_CAMERA_COUNTER,
        obj: obj,
        idCamera: this.data.obj.id,
        idEnterprise: this.data.idEnterprise,
        idHeadquarter: this.data.idHeadquarter,
        headquarters: this.data.headquarters,
      },
      width: '500px',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((_) => {
      if (_.result) {
        this.getList();
      }
    });
  }
}
